<script setup>
import TheAccountTemplate from '@/components/account/template/TheAccountTemplate.vue'
import TheCustomerMetaNavigation from '@/components/basic/atoms/TheCustomerMetaNavigation.vue'
import UspBar from '@/components/basic/atoms/UspBar.vue'
import TheHeader from '@/components/basic/organisms/TheHeader.vue'
import { usePage } from '@/composables/usePage.js'
import { storeToRefs } from 'pinia'
import { defineAsyncComponent, onBeforeMount, ref } from 'vue'

const TheFooter = defineAsyncComponent(
  () => import('@/components/basic/organisms/TheFooter.vue')
)
const MultiTools = defineAsyncComponent(
  () => import('@/components/basic/molecules/MultiTools.vue')
)
const Tool = defineAsyncComponent(
  () => import('@/components/basic/atoms/Tool.vue')
)

const { customer, meta, unHead } = usePage()
const { customerIsAdmin } = storeToRefs(customer)

const adminTool = ref(null)
onBeforeMount(async () => {
  const { TYPES } = await import('@/constants/AdminTool')
  adminTool.value = TYPES
})

meta.title = 'account_page_title'
meta.description = 'account_page_description'
meta.translateValues = true
unHead()
</script>

<template>
  <div id="content" data-elbglobals="page_type:account">
    <UspBar />
    <TheCustomerMetaNavigation />
    <TheHeader />
    <TheAccountTemplate />
    <TheFooter />
    <MultiTools id="fixed-tools" v-if="customerIsAdmin && adminTool">
      <Tool :type="adminTool.TRANSLATE_MODE" />
      <Tool :type="adminTool.SHOW_ELBWALKER_USER_DATA" />
    </MultiTools>
  </div>
</template>
